import store from '../store';
import config from '../../config';

let ws = null;
export default class WSService {
  initSocket(token) {
    // create new connection
    ws = new WebSocket(`${config.websocketUrl}?token=${token}`);
    // register event handlers
    ws.onopen = this.connectionOpened;
    ws.onmessage = this.onMessage;
    ws.onerror = this.onError;
  }

  // when a message is received from socket
  // eslint-disable-next-line
  onClose(messageEvent) {
    console.log('connection closed');
  }

  // when a message is received from socket
  async onMessage(messageEvent) {
    const msgPriority = 1000;
    const msgData = JSON.parse(messageEvent.data);
    if (msgData.priority === msgPriority) {
      // update unread count
      await store.commit(
        'notifications/setUnreadCount',
        msgData.extras.unreadCount
      );
    } else {
      await store.commit('notifications/setNotifsLoading', true);
      await store.commit('notifications/updateNotificationsList', [msgData]);
      await store.commit('notifications/setNotifsLoading', false);
      store.commit(
        'notifications/setUnreadCount',
        store.state.notifications.unreadCount + 1
      );
    }
  }

  onError(err) {
    // TODO: implement after service available

    console.log(err);
  }

  connectionOpened() {
    // TODO: implement after service available
    console.log('connected to websocket');
  }
}
